import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { addMovieBack,handleMovieDetails, handleMoreMovies } from '../actions'

export class Box extends Component {
    render() {
        const {data }= this.props;
     
       const detailsHandle = ()=>{
           const {dispatch} =this.props;
           dispatch(addMovieBack(data.backdrop_path));
           dispatch(handleMovieDetails(data.title));
           dispatch(handleMoreMovies(data.original_language,data.genre_ids[0]));
           window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        }

        

        return (
            <Link className="link" onClick={detailsHandle} to="/movie-details">
            <div className="movie-box" style={{backgroundImage:`url('https://image.tmdb.org/t/p/original/${data.poster_path}')`}}>
               <div className="movie-details">
                 <p className="title">{data.title}</p>
                 <span className="detail"><span>{data.release_date.substr(0,4)}</span>{data.adult&&<span>18+</span>}{!data.adult&&<span className="line">18+</span>}<span>{data.original_language}</span><span className="last">Action</span></span>
               </div>
            </div>
            </Link>
        )
    }
}

export default Box
